import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import PlentyCredentialsSubSubTab from "../../Credentials/PlentyCredentials";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const ShopifyCredentialsSubTab = () => {
  const [shopifySubTab, setShopifySubTab] = useState(0);

  const handleShopifySubTabChange = (event, newValue) => {
    setShopifySubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={shopifySubTab}
              onChange={handleShopifySubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Plenty" />
            </Tabs>
          </Box>

          {/* Plenty Credentials Tab */}
          <TabPanel value={shopifySubTab} index={0}>
            <PlentyCredentialsSubSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ShopifyCredentialsSubTab;
